<template>
  <div
    class="tray"
    :class="{
      fix: !selectionText,
    }"
    ref="tray"
  >
    <AppWindowHeader @pin="pin" @close="onClose" :pinned="pinned" />
    <div class="wrap">
      <fl-editor
        id="tray_editor"
        v-show="true"
        ref="tray_editor"
        :autoFocus="true"
        draftKey="tray_draft:new"
        apiEndPoint="/api/memo/"
        v-on:memo-updated="newMemoCreated"
        :isTray="true"
        :placeholder="$t('memo.placeholder')"
        :traySaveKey="traySaveKey"
        :onUpdate="onUpdate"
        key="tray_editor"
      ></fl-editor>
    </div>
  </div>
</template>

<script>
import FlEditor from './FlEditor.vue'
import { getOsType } from '../utils/utils'
import { getKeyCode } from '../utils/keyCode'
import ThemeManager from '../utils/ThemeManager'
import { getElement } from '../utils/domUtils'
import AppWindowHeader from '../components/Desktop/AppWindowHeader.vue'
export default {
  name: 'MemoTray',
  components: {
    FlEditor,
    AppWindowHeader,
  },
  data() {
    return {
      me: this.$store.state.me,
      pinned: false,
      hover: false,
      height: 160,
      trayHeight: 400,
      isComposing: false,
      hotKeys: [
        {
          key: ['Enter'],
          action: 'newBlank',
          label: 'pages.Hotkey.newBlank',
          hideInWeb: false,
          needPro: false,
          special: true,
        },
        {
          key: [getOsType() == 'mac' ? 'Meta+Enter' : 'Ctrl+Enter'],
          action: 'save',
          label: 'pages.Hotkey.save',
          hideInWeb: false,
          needPro: false,
          special: true,
        },
      ],

      traySaveKey: '',
      fileDomHeight: 0,
      themeManager: null,
      selectionText: '',
    }
  },
  async mounted() {
    window.$global = window.remote.getGlobal('sharedObject')
    const tray = this.$refs.tray

    this.$nextTick(() => {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      this.themeManager = new ThemeManager(mediaQuery)

      const files = this.$refs.tray_editor.$el.querySelector('.files')
      const editor = this.$refs.tray_editor.$el
      this.fileResizeObserver = new ResizeObserver((entries) => {
        const { offsetHeight } = entries[0].target
        const { offsetHeight: trayHeight, offsetWidth: trayWidth } = tray
        let newHeight = 0
        let defaultHeight = 91
        if (offsetHeight > 0) {
          if (offsetHeight > this.fileDomHeight) {
            newHeight = 400 + offsetHeight
          } else if (offsetHeight < this.fileDomHeight) {
            newHeight = trayHeight - offsetHeight + defaultHeight
          } else {
            newHeight = editor.offsetHeight + offsetHeight
          }
        } else {
          newHeight = trayHeight - defaultHeight
        }
        console.log('fileResizeObserver', newHeight, trayWidth)
        this.resizeTray({ width: trayWidth, height: newHeight, animate: true })
        this.fileDomHeight = offsetHeight
      })

      this.fileResizeObserver.observe(files)
    })
    this.handleIPCEvent()
    window.addEventListener('compositionstart', () => {
      this.isComposing = true
    })
    window.addEventListener('compositionend', () => {
      setTimeout(() => {
        this.isComposing = false
      }, 1000)
    })
    window.addEventListener('keydown', this.handleHotkey)
    this.setTraySaveKey()
    document.addEventListener('selectionchange', () => {
      const selection = window.getSelection()
      const selectionText = selection.toString()
      this.selectionText = selectionText
    })

    document.title = 'flomo - 快捷输入'
  },
  methods: {
    handleIPCEvent() {
      window.ipcRenderer.on('tray-process-messages', (event, arg) => {
        const { type } = arg
        if (type === 'show') {
          this.$nextTick(() => {
            if (this.$refs.tray_editor) {
              this.$refs.tray_editor.$el.querySelector('.ProseMirror').focus()
              this.setTraySaveKey()
            }
          })
        }
      })

      window.ipcRenderer.on('resize-tray-window', (e, arg) => {
        const { height } = arg
        const tray = getElement('.tray')
        const ProseMirror = getElement('.ProseMirror')
        const files = getElement('.files')
        if (this.trayHeight !== height) {
          tray.style.height = height + 'px'
          ProseMirror.style.maxHeight = height - 43 - 50 - files.clientHeight + 'px'
        }
        ProseMirror.style.maxHeight = height - 43 - 50 - files.clientHeight + 'px'

        this.trayHeight = height
      })
    },
    newMemoCreated(newMemo) {
      this.$message({
        message:
          `<p class='text'><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.99984 1.16666C3.77809 1.16666 1.1665 3.77824 1.1665 6.99999C1.1665 10.2217 3.77809 12.8333 6.99984 12.8333C10.2216 12.8333 12.8332 10.2217 12.8332 6.99999C12.8332 3.77824 10.2216 1.16666 6.99984 1.16666ZM5.83317 10.1582L3.08742 7.41241L3.91225 6.58757L5.83317 8.50849L10.0874 4.25424L10.9123 5.07907L5.83317 10.1582Z" fill="#55BB8E"/>
</svg> <span>` +
          this.$t('fleditor.send-success') +
          '</span></p>',
        duration: 1000,
        offset: 12,
        customClass: 'init-tip send-tip',
        iconClass: '',
        dangerouslyUseHTMLString: true,
      })

      setTimeout(() => {
        if (!this.pinned) {
          window.ipcRenderer.send('closeTrayWindow', true)
        }
        this.resizeTray({ width: 380, height: 400, animate: true })
      }, 1200)
    },
    onClose() {
      window.ipcRenderer.send('closeTrayWindow', true)
    },
    pin() {
      this.pinned = !this.pinned
      this.$store.commit('setTrayPinned', this.pinned)
      window.ipcRenderer.send('pin', this.pinned)
    },
    handleHotkey(e) {
      if (this.isComposing) {
        return
      }
      let hotKeys = localStorage.hotkeys ? JSON.parse(localStorage.hotkeys) : this.hotKeys
      // 兼容上个版本的快捷键设置
      hotKeys.forEach((item) => {
        if (item.action == 'save' && typeof item.key == 'string') {
          if (getOsType() == 'win') {
            item.key = item.key.replace('Meta', 'Ctrl')
          }
          item.key = [item.key]
        }

        if (item.action == 'newBlank' && typeof item.key == 'string') {
          item.key = [item.key]
        }
      })
      const { altKey, ctrlKey, shiftKey, key, code, metaKey, keyCode } = e
      let controlKey = ''
      ;[
        { key: metaKey, text: 'Meta' },
        { key: ctrlKey, text: 'Ctrl' },
        { key: shiftKey, text: 'Shift' },
        { key: altKey, text: 'Alt' },
      ].forEach((curKey) => {
        if (curKey.key) {
          if (controlKey) controlKey += '+'
          controlKey += curKey.text
        }
      })
      if (key) {
        if (controlKey) controlKey += '+'
        controlKey += getKeyCode(keyCode)
      }

      hotKeys.map((hot) => {
        if (typeof hot.key !== 'string' && hot.key.indexOf(controlKey) > -1) {
          const { action } = hot

          switch (action) {
            case 'save':
              if (this.$refs.tray_editor) {
                this.$refs.tray_editor.onSubmit()
              }

              break

            default:
              break
          }
          e.preventDefault()
          e.stopPropagation()
          return false
        }
      })

      return true
    },
    setTraySaveKey() {
      let keys = localStorage.hotkeys ? JSON.parse(localStorage.hotkeys) : this.hotKeys
      // this.traySaveKey = keys.filter((item) => item.action == 'save')[0].key.replace('Shift+', '⇧ + ')
      let key = keys.filter((item) => item.action == 'save')[0].key
      let osType = getOsType()

      // 兼容之前的设置
      if (typeof key == 'string') {
        if (osType == 'mac') {
          if (key.indexOf('Shift') > -1) {
            key = key.replace('Shift+', '⇧ + ')
          }
          if (key.indexOf('Meta') > -1) {
            key = key.replace('Meta+', '⌘ + ')
          }
        } else {
          key = key.replace('Meta+', 'Ctrl + ')
        }
      } else {
        key = key.map((item) => {
          let keyStr = item

          if (osType == 'win') {
            keyStr = keyStr.replace('Meta+', 'Ctrl + ')
          } else {
            if (keyStr.indexOf('Shift') > -1) {
              keyStr = keyStr.replace('Shift+', '⇧ + ')
            }
            if (keyStr.indexOf('Meta') > -1) {
              keyStr = keyStr.replace('Meta+', '⌘ + ')
            }
          }
          return keyStr
        })

        key = key.join(' / ')
      }
      this.traySaveKey = key
    },
    onUpdate() {
      const files = getElement('.files')
      const tray = this.$refs.tray
      const proseMirror = getElement('.ProseMirror')
      const filesOffsetHeight = files.offsetHeight
      // 获取屏幕高度
      let screenHeight = window.screen.height
      const maxHeight = screenHeight * 0.85 - filesOffsetHeight

      let trayOffsetHeight = tray.offsetHeight
      let proseMirrorScrollHeight = proseMirror.scrollHeight
      const resizeTray = (newHeight) => {
        newHeight = Math.min(screenHeight * 0.85, Math.max(400, newHeight))
        console.log(newHeight)
        this.resizeTray({
          width: tray.offsetWidth,
          height: newHeight,
          animate: true,
        })
      }
      if (proseMirrorScrollHeight > 300) {
        if (proseMirror.offsetHeight < maxHeight && proseMirrorScrollHeight > this.height) {
          trayOffsetHeight += 25
          resizeTray(trayOffsetHeight)
        } else if (proseMirrorScrollHeight < this.height && proseMirrorScrollHeight > 300) {
          let relProseMirrorMaxHeight = trayOffsetHeight - 103 - filesOffsetHeight
          if (relProseMirrorMaxHeight > 300) {
            trayOffsetHeight -= 25
            resizeTray(trayOffsetHeight)
          }
        }
      }

      // 内容清空时，恢复窗口默认高度
      let isEmpty = this.$refs.tray_editor.editor.isEmpty
      if (isEmpty) {
        this.resizeTray({ width: 380, height: trayOffsetHeight, animate: true })
      }

      this.height = proseMirrorScrollHeight
    },

    resizeTray(data) {
      // setSize 需要去整，小数会报错
      data.width = parseInt(data.width)
      data.height = parseInt(data.height)
      window.ipcRenderer.send('resize-tray', data)
    },
  },
  beforeDestroy() {
    this.themeManager.dispose()
    this.fileResizeObserver.disconnect()
  },
  watch: {
    selected_tag: function (new_selected_tag, old_selected_tag) {
      this.new_tag_name = new_selected_tag
      if (this.$refs.tray_editor && this.$refs.tray_editor.editor) {
        if (!this.$refs.tray_editor.editor.getHTML()) {
          this.$refs.tray_editor.editor.commands.setContent(this.decorateHashTag(new_selected_tag))
          return
        }
        if (old_selected_tag === null) {
          this.$refs.tray_editor.editor.commands.setContent(
            this.decorateHashTag(new_selected_tag) + this.$refs.tray_editor.editor.getHTML(),
          )
          return
        }
        if (new_selected_tag === null) {
          let content = this.$refs.tray_editor.editor.getHTML()
          this.$refs.tray_editor.editor.commands.setContent(content.replace('#' + old_selected_tag + '', ''))
          return
        }

        if (this.$refs.tray_editor.editor.getHTML().includes('#' + old_selected_tag)) {
          this.$refs.tray_editor.editor.commands.setContent(
            this.$refs.tray_editor.editor.getHTML().replace('#' + old_selected_tag, '#' + new_selected_tag),
          )
        } else {
          this.$refs.tray_editor.editor.commands.setContent(
            '<p>#' + new_selected_tag + '</p>' + this.$refs.tray_editor.editor.getHTML(),
          )
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tray {
  height: 400px;
  width: 100%;
  overflow: hidden;
  background: var(--defaultBg);
  position: relative;
  width: 100%;

  .wrap {
    // height: calc(100vh - 45px);
    // overflow-y: auto;
    margin-top: 10px;

    &::-webkit-scrollbar {
      width: 10px !important;
      height: 40px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #efefef !important;
      border-radius: 10px !important;
      cursor: pointer;
    }

    .blurd,
    .focused {
      border: none !important;
      box-shadow: none !important;
    }
  }
}

.fix {
  .header {
    -webkit-app-region: drag;
  }
}
</style>
<style>
.tray .editor-content {
  padding-top: 0px !important;
}

.tray div.editor-menu-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: var(--defaultBg);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tray div .files {
  position: fixed;
  bottom: 40px;
  left: 0;
  width: 100%;
}

.tray .files {
  margin-top: -15px;
}

.send-tip {
  background: rgba(0, 0, 0, 0.8) !important;
  border-radius: 6px !important;
  min-width: 94px !important;
}

.send-tip .text {
  font-size: 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-tip svg {
  margin-right: 8px !important;
}

body.dark_mode .tray .input-box:hover {
  border: none !important;
}
</style>
